export default __webpack_public_path__ + "static/media/alert-icon.2400b30b.svg";